import { useCallback, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';

export const useKeyboardKeyListener = (key: string, callback: () => void) => {
  const buttonHandler = useCallback((event) => {
    if (event.key === key) {
      //Do whatever when the button is pressed
      callback();
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", buttonHandler, false);

    return () => {
      document.removeEventListener("keydown", buttonHandler, false);
    };
  }, []);
};